import { format, parseISO } from "date-fns";
import { es } from "date-fns/locale";
import { Property } from "@/types/property";

const mapSupabaseProperty = (property: any): Property => ({
  id: property.id,
  title: property.title,
  location: property.location || '', // Added required location field
  shortDescription: property.short_description,
  longDescription: property.long_description,
  operationStartedAt: property.operation_started_at 
    ? format(parseISO(property.operation_started_at), "yyyy-MM-dd")
    : '',
  price: property.price,
  cleaningFee: property.cleaning_fee || 0,
  rating: property.rating,
  guests: property.guests,
  images: property.images || [],
  bedrooms: property.bedrooms,
  bathrooms: property.bathrooms,
  area: property.area || 0,
  available: property.available,
  latitude: property.latitude,
  longitude: property.longitude,
  shortName: property.short_name,
  name: property.name,
  featured: property.featured,
  airbnbUrl: property.airbnb_url,
  hostId: property.host_id,
  neighborhoodId: property.neighborhood_id,
  propertyHighlights:
    property.property_highlights?.map((h: any) => ({
      title: h.title,
      description: h.description,
      icon: h.icon,
    })) || [],
  host: property.hosts
    ? {
        name: property.hosts.name,
        avatar: property.hosts.avatar || "",
        superHost: property.hosts.super_host || false,
        experience: property.hosts.experience || "",
      }
    : undefined,
  neighborhood: property.neighborhoods
    ? {
        city: property.neighborhoods.city,
        state: property.neighborhoods.state,
        country: property.neighborhoods.country,
        description: property.neighborhoods.description || "",
        longDescription: property.neighborhoods.long_description || "",
      }
    : undefined,
  reviews:
    property.reviews?.map((r: any) => ({
      id: r.id,
      name: r.name,
      rating: r.rating,
      comment: r.comment,
      location: r.location || "",
      date: r.date,
    })) || [],
  
  // WiFi
  wifiNetwork: property.wifi_network,
  wifiPassword: property.wifi_password,
  
  // Entry Instructions
  entryDescription: property.entry_description,
  entryVideoUrl: property.entry_video_url,
  securityCode: property.security_code,
});

export default mapSupabaseProperty;
